<template>
  <div class="dates-selector">
    <div class="tab">
      <span class="descr icon" v-on:click="retornarData"><i class="icon-arrow-left-circle"></i></span>
      <span class="descr"> Exibindo de</span>
      <datepicker input-class="date form-control" :language="ptBR" v-model="datas.inicio"></datepicker>
      <span class="descr">à</span>
      <datepicker input-class="date form-control" :language="ptBR" v-model="datas.fim"></datepicker>
      <span class="descr icon" v-on:click="avancarData"><i class="icon-arrow-right-circle"></i></span>
    </div>
  </div>
</template>

<style lang="scss">
.dates-selector {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: -1px;

  .descr {
    display: inline-block;
    font-size: 20px;

    .icon-arrow-left-circle {
      margin-right: 10px;
    }
  }

  .vdp-datepicker {
    display: inline-block;

    input.date {
      text-align: center;
      background-color: white !important;
      border: 1px solid white !important;
      color: #23282c !important;
      font-weight: 700;
      font-size: 20px;
      width: 150px !important;
    }
  }

  .tab {
    background-color: white;
    padding: 10px 30px;
    border-radius: 15px 15px 0 0;
    border: 1px solid #ccc;
    border-bottom: none;
  }
}
</style>

<script>
import { ptBR } from 'vuejs-datepicker/dist/locale';
import Datepicker from 'vuejs-datepicker';

export default {
  name: 'SelecionarPeriodoDatas',

  components: {
    Datepicker,
  },

  props: {
    setDateCallback: {
      type: Function,
      default: () => {}
    },
    changeDateCallback: {
      type: Function,
      default: () => {}
    },
  },  

  data() {
    return {
      datas: {
        inicio: null,
        fim: null,
      },
      ptBR: ptBR,
    }
  }, 

  mounted() {
    this.datas = {
      inicio: new Date().setDate(new Date().getDate() - 6),
      fim: new Date(),
    };
  },

  watch: {
    'datas.inicio'() {
      if (this.getDiferencaDias() !== 6 || !this.datasValidas) {
        const data = new Date(this.datas.inicio);
        this.datas.fim = data.setDate(data.getDate() + 6);
      }

      this.setDateCallback({ ...this.datas })
      this.changeDateCallback();
    },

    'datas.fim'() {
      if (this.getDiferencaDias() !== 6 || !this.datasValidas) {
        const data = new Date(this.datas.fim);
        this.datas.inicio = data.setDate(data.getDate() - 6);
      }
    },
  },

  methods: {
    avancarData() {
      const data = new Date(this.datas.inicio);
      this.datas.inicio = data.setDate(data.getDate() + 7);
    },

    retornarData() {
      const data = new Date(this.datas.inicio);
      this.datas.inicio = data.setDate(data.getDate() - 7);
    },

    getDiferencaDias() {
      const dtInicio = new Date(this.datas.inicio);
      const dtFim = new Date(this.datas.fim);
      return Math.ceil(Math.abs(dtFim.getTime() - dtInicio.getTime()) / (1000 * 3600 * 24));
    },
  }
}
</script>